import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductService } from 'src/app/service/product.service';
import { SaleService } from 'src/app/service/sale.service';
import { SaleDialogComponent } from '../sale-dialog/sale-dialog.component';
import { SaleDialogImprimirComponent } from '../sale-dialog-imprimir/sale-dialog-imprimir.component';
import { ProductSold } from './productSold';
import { Sale } from './sale';
import { ClientService } from 'src/app/service/client.service';
import { saveAs } from 'file-saver';
import { HttpResponse} from '@angular/common/http';
import { NotaFiscalDialogComponent } from '../nota-fiscal-dialog/nota-fiscal-dialog.component';

@Component({
  selector: 'app-sale',
  templateUrl: './sale.component.html',
  styleUrls: ['./sale.component.css']
})
export class SaleComponent implements OnInit {

  productsSolds: ProductSold[] = [];
  formAddItem: FormGroup;
  //ordem das colunas no html 
  ordemColunasTabela = ['id', 'quantity', 'name', 'price','desconto', 'priceTotal','remover'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend
  statusCaixa = "Caixa Livre";
  data: any
  pagar: any;
  typesSale: String[] = ['Entrega','Portaria'];
  typeSale: any;
  nameProduct: string;
  nameClient: string;
  formasPagamento: String[] = ['A Receber','Cartao','Dinheiro','Pix','Permuta','Pagamento Antecipado'];
  formaPagamento: string;
  sale: Sale;
  formModalBoleto: any;
  clienteID: any;
  relatorioURL: any;
  

  constructor(
    private productService: ProductService,
    private clientService: ClientService,
    private saleService: SaleService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {    
    if (localStorage.getItem('clienteVenda') !== null) {
      this.clienteID = localStorage.getItem('clienteVenda')
      localStorage.removeItem('clienteVenda')
      this.formAddItem = this.formBilder.group({ 
        id: [null, [Validators.required, Validators.maxLength(13), Validators.minLength(1)]],
        quantidade: [null, [Validators.required, Validators.maxLength(50)]],       
        clientSolds: parseInt(this.clienteID.toString().trim()),
        observation: [],
        desconto: 0,
      })
      this.buscarClient();
    }else{
      this.montarFormulario();
    }    
  }

  montarFormulario() {
    this.formAddItem = this.formBilder.group({
      //validando os dados do formulário
      id: [null, [Validators.required, Validators.maxLength(13), Validators.minLength(1)]],
      quantidade: [null, [Validators.required, Validators.maxLength(50)]],
      clientSolds: [null, [Validators.required, Validators.maxLength(13), Validators.minLength(1)]],
      observation: [],
      desconto: 0,
    })
  }

  limparFormulario() {
    this.formAddItem.reset();
    this.productsSolds = [];
    this.statusCaixa = "Caixa Livre";
    this.nameProduct = "";
    this.nameClient = "";
    this.formaPagamento = "";  
    this.montarFormulario(); 
  }

  openDialog(): void {
    //verificar se existe itens na tabela
    if (this.productsSolds.length <= 0) {
      this.snackBar.open('É necessário inserir ao menos um item para realizar a venda venda!', 'Atenção', {
        duration: 3000
      })
    } else {
      //abrir dialog
      let dialogRef = this.dialog.open(SaleDialogComponent, {
        width: '300px',
        data: {
          //itens que serão levados do pdv para o dialog
          payment: this.formaPagamento.toUpperCase(),
          pagar: this.pagar
        }
      });
      //confirmar venda
      dialogRef.afterClosed().subscribe(result => {
        const venda = new Sale(
          null,
          result.pagar,
          parseFloat(String(result.pago).replace(",", ".")),
          parseFloat(String(result.troco).replace(",", ".")),
          result.payment,
          this.productsSolds,
          this.sale.typeSale,
          this.sale.clientSolds,
          this.sale.observation,
          result.formaPagamento,
          result.createdAt,
          result.clientName,
          result.payment === 'A_RECEBER' || result.payment2 === 'A_RECEBER' ? 1 : 0,
          parseFloat(String(result.pago2).replace(",", ".")),
          result.payment2
        );

        // salvar venda
        this.saleService.save(venda).subscribe(resposta => {          
          this.openDialogNotaFiscal(resposta.id);
        }, errorResponse => {
          this.snackBar.open(errorResponse.error.message, 'ERRO', {
            duration: 2000
          })
        })
      });
    }
  }
  
  openDialogNotaFiscal(id: number) {
    const dialogRef = this.dialog.open(NotaFiscalDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitirNotaFiscal(id);        
      }
      this.snackBar.open('Venda realizada com sucesso!', 'Sucesso', {
        duration: 2000
      })
      this.limparFormulario();
    });
  }


  load() {
    //Session storage salva os dados como string
    (sessionStorage.refresh == 'true' || !sessionStorage.refresh) && location.reload();
    sessionStorage.refresh = true;
  }

  adicionarItem() {
    const formValues = this.formAddItem.value;
    this.productService.findProductByIdActive(formValues.id).subscribe((response) => {
      const total = ((this.typeSale === 'Portaria' ? 
      (this.formaPagamento === 'A Receber' && formValues.id == 1 ? response.priceReceivable : response.pricePort) :
      (this.formaPagamento === 'A Receber' && formValues.id == 1 ? response.priceReceivable  : response.price)) * formValues.quantidade) - parseFloat(String(formValues.desconto).replace(",", "."));
      const productSold = new ProductSold(
        null,
        response,
        this.typeSale === 'Portaria' ? 
        (this.formaPagamento === 'A Receber' && formValues.id == 1 ? response.priceReceivable : response.pricePort) :
        (this.formaPagamento === 'A Receber' && formValues.id == 1 ? response.priceReceivable : response.price),
        total,
        formValues.quantidade,
        this.productsSolds.length + 1,
        parseFloat(String(formValues.desconto).replace(",", "."))
      );

      this.productsSolds = this.productsSolds.concat(productSold);
      this.statusCaixa = "Venda em Aberto";
      this.sale = new Sale(
        null,
        100,
        parseFloat(String(100).replace(",", ".")),
        parseFloat(String(0).replace(",", ".")),
        null,
        this.productsSolds,
        this.typeSale,
        formValues.clientSolds,
        formValues.observation,
        this.formaPagamento,
        '',
        '',
        null,
        parseFloat(String(100).replace(",", ".")),
        null
      );
    }, errorResponse => {
      // exibir mensagem snackbar
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      })
    })
  }

  getTotalCost() {
    this.pagar = this.productsSolds.map(t => t.priceTotal).reduce((acc, value) => acc + value, 0)
    return this.pagar;
  }

  buscarProduto() {
    const formValues = this.formAddItem.value;
    this.productService.findProductByIdActive(formValues.id).subscribe((response) => {
      this.nameProduct = response.name;         
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      })
    })
  }

  buscarClient() {
    const formValues = this.formAddItem.value;
    this.clientService.findClientById(formValues.clientSolds).subscribe((response) => {
      this.nameClient = response.razaoSocial;         
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      })
    })
  }

  imprimir(){
    if (this.productsSolds.length <= 0) {
      this.snackBar.open('É necessário inserir ao menos um item para realizar a venda venda!', 'Atenção', {
        duration: 3000
      })
    } else{
      this.mostrarLoading();
      this.saleService.imprimir(this.sale).subscribe(resposta => {
        this.cupomFiscal();
      }, errorResponse => {        
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
        this.fecharLoading();
      });
   }
  }

  cupomFiscal(){
     this.saleService.cupomFiscal().subscribe(
        (response: any) => {          
          const file = new Blob([response.body],{});
          const blob = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = blob;
          link.download = 'cupomFiscal.pdf';
          link.click();
          window.URL.revokeObjectURL(blob);
          link.remove();
          this.fecharLoading();
        },
        error => {
          console.error('Ocorreu um erro ao gerar o relatório:', error);
          this.fecharLoading();
        }
      );   
  }


  imprimirDialog(): void {   
      let dialogRef = this.dialog.open(SaleDialogImprimirComponent, {
        width: '600px',
        height: '500px',
        data: {
          pagar: this.pagar
        }
      }); 
    
  }  

  removerItem(item: number): void {
    this.productsSolds = this.productsSolds.filter(sold => sold.item !== item);
    let Atualizar = 1;
    this.productsSolds.forEach(sold =>  {
      sold.item = Atualizar++;
    });
    this.sale.productSolds = this.productsSolds;
  }

  public mostrarLoading() {
    let load = document.getElementById('preloader');
    load?.setAttribute("style", "display:block;");
  }
  public fecharLoading() {
    let load = document.getElementById('preloader');
    load?.setAttribute("style", "display:none;");
  }

  emitirNotaFiscal(id: number) {
    this.mostrarLoading();
    this.saleService.emitirNotaFiscal(id).subscribe((response: any) => {      
      const file = new Blob([response.body],{});
         const blob = window.URL.createObjectURL(file);
         const link = document.createElement('a');
         link.href = blob;
         link.download = 'notaFiscal.pdf';
         link.click();
         window.URL.revokeObjectURL(blob);
         link.remove();
         this.fecharLoading();
       },
       error => {
         console.error('Ocorreu um erro ao gerar a nota Fiscal:', error);
         this.fecharLoading();
       })
  }
}